import { graphql } from '@/generated/gql';

export const INTAKE_CHAT_REQUEST_MESSAGE_STEP_MUTATION = graphql(/* GraphQL */ `
  mutation IntakeChatRequestMessageStepMutation($data: SvbrgChatRequestMessageInput!) {
    sevenbridges {
      chatSession {
        chatRequestMessage {
          generate(data: $data) {
            id
          }
        }
      }
    }
  }
`);
